import { render, staticRenderFns } from "./AlertNotice.vue?vue&type=template&id=0f9cdfca&scoped=true"
import script from "./AlertNotice.vue?vue&type=script&lang=ts"
export * from "./AlertNotice.vue?vue&type=script&lang=ts"
import style0 from "./AlertNotice.vue?vue&type=style&index=0&id=0f9cdfca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9cdfca",
  null
  
)

export default component.exports